import { Pressable, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { colors } from '../../theme'
import { body3, label1, label2 } from '../../theme/typography'

type SectionErrorStateProps = Readonly<{
  message: string
  onRetry: () => void
  testID?: string
  title: string
}>

export function SectionErrorState({
  message,
  onRetry,
  testID,
  title,
}: SectionErrorStateProps) {
  const { t } = useTranslation(['common'])

  return (
    <View
      testID={testID}
      className="mb-2 rounded-lg border px-4 py-3"
      style={{
        borderColor: colors.destructive,
        backgroundColor: colors.errorBackground,
      }}
    >
      <Text style={{ ...label1, color: colors.ink }}>{title}</Text>
      <Text className="mt-1" style={{ ...body3, color: colors.inkSecondary }}>
        {message}
      </Text>
      <Pressable
        className="mt-3 h-9 self-start rounded-lg bg-primary px-4 items-center justify-center"
        onPress={onRetry}
      >
        <Text style={{ ...label2, color: colors.primaryForeground }}>
          {t('common:error_try_again')}
        </Text>
      </Pressable>
    </View>
  )
}
